import { render, staticRenderFns } from "./SidebarMenuSetting.vue?vue&type=template&id=5cc8e88a&"
import script from "./SidebarMenuSetting.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenuSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports